export const createIntervalWithTimeout = (
  intervalCheckCallback: () => boolean,
  intervalCallback: () => void,
  timeoutCallback?: () => void,
  interval = 100,
  timeout = 5000,
): void => {
  let intervalId: number | undefined;
  const timeoutId = window.setTimeout(() => {
    window.clearInterval(intervalId);
    window.clearTimeout(timeoutId);
    if (timeoutCallback) {
      timeoutCallback();
    }
  }, timeout);
  intervalId = window.setInterval(() => {
    if (intervalCheckCallback()) {
      window.clearTimeout(timeoutId);
      window.clearInterval(intervalId);
      intervalCallback();
    }
  }, interval);
};
